import React, { Component } from 'react'
import { TryMap, FullCalendarCmp } from '../../components/index'

class DashboardDeliveries extends Component {
    render() {
        const { Waypoints, ActualDeliveries, InitEvents, CalendarFunctions, view } = this.props
        return (
            <div className='m-5'>
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className='row'>
                            <div className="col-lg-8 mb-4 order-0">
                                <div className="card">
                                    <div className="d-flex align-items-end row">
                                        <div className="col-sm-12">
                                            <div className="card-body" >
                                                <div>
                                                    <TryMap
                                                        waypoints={Waypoints}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 order-2 mb-4">
                                <div className="card h-100">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <h5 className="card-title m-0 me-2">Entregas en curso (Hoy)</h5>
                                        <div className="dropdown">
                                        </div>
                                    </div>
                                    <div className="card-body scrollCardBP" >
                                        <ul className="p-0 m-0">
                                            {ActualDeliveries && ActualDeliveries.length > 0 &&
                                                ActualDeliveries.map((delivery) => {
                                                    return (
                                                        <>{delivery && delivery.IsActive === "1" &&
                                                            <li className="d-flex mb-4 pb-1" >
                                                                <div className="avatar flex-shrink-0 mr-2 ml-2 mt-2" >
                                                                    <img style={{ width: '3.5vh' }} src={require('../../images/ico/deliveries.png')} alt="User" className="rounded" />
                                                                </div>
                                                                <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                    <div className="me-2">

                                                                        <h6 className="mb-0">{delivery.DriverName} Vehículo: {delivery.TipodeUnidad}  Placa: {delivery.PlacaVM ?? ""}</h6>
                                                                        <small className="text-muted d-block mb-1">{delivery.Code ?? ""}</small>
                                                                    </div>
                                                                    <div className="user-progress d-flex align-items-center gap-1 mr-2">
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        }</>


                                                    )
                                                })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-lg-8 mb-4 order-0">
                                <div className="card">
                                    <div className="d-flex align-items-end row">
                                        <div className="col-sm-12">
                                            <div className="card-body h-100" >
                                                <div className="h-100">
                                                    <FullCalendarCmp
                                                        initEvents={InitEvents}
                                                        calendarFunctions={CalendarFunctions}
                                                        view={view}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="content-backdrop fade"></div>
                </div>
            </div>
        )
    }


}


export default DashboardDeliveries